import CryptoJS from "crypto-js";
const key = CryptoJS.enc.Utf8.parse("Z4NMqZEvvScXIxwk");
const iv = CryptoJS.enc.Utf8.parse("vg96EmbXrpPSICat");


export { encrypt, decrpt, decrptdata, encryptedString }

//alert(iv);
function encrypt(text) {
    text = JSON.stringify(text);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), key, { iv: iv }).toString();
    return encrypted;
}

function decrpt(data) {
    var decData = CryptoJS.AES.decrypt(data, key, { iv: iv }).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decData);
}

function decrptdata(data) {
    var decData = CryptoJS.AES.decrypt(data, key, { iv: iv }).toString(CryptoJS.enc.Utf8);
    return decData;
}

function encryptedString(str) {

    const str2 = (str.length / 2) - 1;
    const str3 = (Number(str2) > 10) ? 10 : str2;
    const res = str.substr(str2, str3);
    const newStringArray = str.split('');
    newStringArray.splice(str2, str3)
    var obj =
    {
        req: newStringArray.join(''),
        token: res
    }
    return obj;
}
